export interface UserRecentCreate {
  subjectIdentifier: string;
}

export enum RecentSubject {
  Method = 'method',
  Arrangement = 'arrangement',
  Resource = 'resource',
}
export interface UserRecent {
  createdAt: string;
  parentIdentifier?: string;
  subject: RecentSubject;
  subjectIdentifier: string;
}

export interface UserRecents {
  recentMethods: Array<UserRecent>;
  recentArrangements: Array<UserRecent>;
  recentResources: Array<UserRecent>;
}

export const AllowedRecentResourceTypes = ['paragraph', 'chapter'];
